module.exports = __webpack_public_path__ + "img/logo-o-green.411cf858.svg";